<template>
  <div class="wrapper">
    <div
      class="insure_header"
      style="background-color: white; min-height: 100%"
    >
      <img
        v-show="!$ComTools.isEmptyString(bgSrc)"
        class="header_img"
        :src="'/api/file' + bgSrc"
      />
    </div>
    <div class="button-save">
      <van-button @click="handleGoClick" type="primary" block color="#FFC281"
        >立即投保</van-button
      >
    </div>
    <div class="flot-box" @click="handleGoListClick">
      <van-icon name="orders-o" color="white" size="40px" />
    </div>
  </div>
</template>

<script>
import { getJsapiTicket, getProductList } from "@/api/common";
import { Notify } from "vant";
export default {
  data() {
    return {
      itemIndex: "",
      belongerId: "",
      productId: "",
      tabList: [],
      itemList: [],
      bgSrc: "",
    };
  },
  created() {
    document.title = "阳光保险";
    this.belongerId = this.$route.query.belongerId || "";
    this.productId = this.$route.query.productId || "";
    if (!this.$ComTools.isEmptyString(this.productId)) {
      this.findProductList();
    } else {
      Notify("参数错误");
    }
  },
  mounted() {
    let sUrl = location.href.split("#")[0];
    let sImgUrl = "http://nywx.e-ibdt.cn/file/logo/logo_sinosig.png";
    getJsapiTicket({ appid: process.env.WXKey, url: sUrl }).then((res) => {
      if (res.code === 0) {
        this.$ComTools.wxShare(res.data, sUrl, sImgUrl, "阳光保险");
      }
    });
  },
  methods: {
    findProductList() {
      getProductList({ id: this.productId }).then((res) => {
        if (res.code === 0) {
          if (res.data.length > 0) {
            this.bgSrc = res.data[0].coverImg;
          }
        }
      });
    },
    handleGoClick() {
      this.$router.push({
        path: "/insure/tbform",
        query: {
          belongerId: this.belongerId,
          productId: this.productId,
        },
      });
    },
    handleGoListClick() {
      this.$router.push({
        path: "/insure/tb_list",
        query: { id: this.productId },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  height: 100%;
  background-color: #ecf5f6;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .button-save {
    /deep/ .van-button {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      // color: black !important;
    }
  }
  .flot-box {
    width: 50px;
    height: 50px;
    background-color: #ffc281;
    position: fixed;
    bottom: 135px;
    right: 25px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 0 5px 0 rgba(255, 194, 129, 1);
  }
}
</style>


// WEBPACK FOOTER //
// src/views/insurance/insure_n.vue